<template>
  <div>
    <v-card
      flat
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          xs10
        >
          <v-text-field
            v-model="searchText"
            :label="searchLabelText"
            class="customizeLabel mt-5 mr-3"
          />
        </v-flex>
        <v-flex
          v-if="downloading && searchText !== ''"
          xs2
          class="mt-6"
        >
          <v-progress-circular
            indeterminate
            color="secondary"
            class="ml-3"
          />
        </v-flex>
      </v-layout>
      <scrollable-list
        v-if="shouldShowList"
        :size="50"
        :remain="8"
        :bench="10"
        class="mt-3"
      >
        <v-list
          two-line
          subheader
        >
          <template
            v-for="servicer in searchResults"
          >
            <v-list-tile
              :key="servicer.id"
              class="px-3 mt-3 hoverable"
              avatar
              @click="selectedServicer = servicer; confirmExpertDialog = true"
            >
              <v-list-tile-avatar>
                <default-avatar
                  :image-url="servicer.profile_url"
                  :servicer-name="fullName(servicer)"
                />
              </v-list-tile-avatar>
              <v-list-tile-content
                class="pl-4"
              >
                <v-list-tile-title>
                  {{ fullName(servicer) }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{ location(servicer) }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </scrollable-list>
    </v-card>
    <borrower-business-card
      v-if="!isEmptyObject(selectedServicer)"
      v-model="confirmExpertDialog"
      :action-text="'Select'"
      :has-action="true"
      :servicer="selectedServicer"
      @action="confirmServicerAndContinue"
    />
    <v-layout
      row
      wrap
      class="text-xs-center"
    >
      <v-flex
        md12
        xs8
        class="mt-6"
      >
        <v-btn
          class="mx-auto btn--xlarge primary text--white sel_button_get_skip"
          style="width:175px;"
          color="primary"
          outline
          @click="$emit('choice-made', 'skip_selection')"
        >
          Continue
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import snCompaniesService from '../../services/snCompaniesService.js'
import borrowerBusinessCard from '../borrowerApp/borrowerBusinessCard.vue'
import defaultAvatar from './defaultAvatar.vue'
import scrollableList from 'vue-virtual-scroll-list'
import _ from 'lodash'
export default {
  name: 'ChooseLo',
  components: {
    'scrollable-list': scrollableList,
    'borrower-business-card': borrowerBusinessCard,
    'default-avatar': defaultAvatar
  },
  props: {
    activationCode: {
      type: String,
      default: '',
      required: true
    }
  },
  data () {
    return {
      confirmExpertDialog: false,
      customTitle: 'Are you working with someone on your loan?',
      downloading: false,
      searchResults: [],
      searchLabelText: 'Search by name, city, or location',
      searchText: '',
      servicerProfiles: [],
      selectedServicer: {}
    }
  },
  computed: {
    shouldShowList () {
      if (this.searchText === '') return false
      if (this.searchText !== '' && this.searchResults.length === 0) return false
      return true
    }
  },
  watch: {
    searchText: {
      handler: function (oldVal, newVal) {
        const debouncedSearch = _.debounce(this.queryServicers, 500)
        debouncedSearch()
      }
    }
  },
  created () {
    if (_.get(this, '$store.borrowerWebContent.chooseLoHeaderText', false)) this.customTitle = this.$store.borrowerWebContent.chooseLoHeaderText
    // Currently UX wants the web title for this step to be different from the title
    // used by web/returned from the stateDefinition. This event customizes the title.
    this.$emit('customize-title', this.customTitle)
  },
  methods: {
    confirmServicerAndContinue (newSac) {
      this.$emit('choice-made', 'save_servicer', newSac)
    },
    fullName (servicer) {
      return servicer.name + ' ' + servicer.last_name
    },
    isEmptyObject (givenObject) {
      if (Object.keys(givenObject).length === 0) return true
      else return false
    },
    location (servicer) {
      if (servicer.city) {
        return servicer.city + ', ' + servicer.state
      } else if (servicer.state) {
        return servicer.state
      } else { return '' }
    },
    queryServicers () {
      this.downloading = true
      if (this.searchText === '') {
        this.searchResults = []
      } else {
        snCompaniesService.searchCompanyServicers(this.activationCode, this.searchText).then(response => {
          this.downloading = false
          const servicerProfiles = _.get(response, 'data.public.company.servicer_profiles', [])
          if (servicerProfiles) {
            this.searchResults = servicerProfiles
          }
        })
      }
    }
  }
}
</script>
<style>
.customizeLabel label {
  text-transform: none !important;
}
.progressCircle {
  text-align: center;
}
</style>
